import { Box, Card, Tab, Tabs } from "@mui/material";
import React, { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import AlertContent from "./TabContent/AlertContent";
import ActionsContent from "./TabContent/ActionsContent";
import ActionIssuesContent from "./TabContent/ActionIssuesContent";
import CarePlansContent from "./TabContent/CarePlansContent";
import HandoverContent from "./TabContent/HandoverContent";
import WeightsContent from "./TabContent/WeightsContent";
import TempChartContent from "./TabContent/TempChartContent";
import OxygenChartContent from "./TabContent/OxygenChartContent";
import FluidChartContent from "./TabContent/FluidChartContent";
import BowelChartContent from "./TabContent/BowelChartContent";
import IncidentContent from "./TabContent/IncidentContent";
import DolsContent from "./TabContent/DolsContent";
import RecordAbsenseContent from "./TabContent/RecordAbsenseContent";
import NEWS2Content from "./TabContent/NEWS2Content";
import UnAllocatedCandidates from "./TabContent/UnAllocatedCandidates";

const OperationTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Alerts", value: "alerts" },
    { label: "Actions", value: "actions" },
    { label: "Action Issues", value: "action-issues" },
    { label: "Care Plans", value: "care-plans" },
    { label: "Handover", value: "handover" },
    { label: "DoLS", value: "dols" },
    { label: "Incidents", value: "incidents" },
    { label: "Family Share", value: "family-share" },
    { label: "Weight", value: "weight-chart" },
    { label: "Fluid", value: "fluid-chart" },
    { label: "Temp", value: "temp-chart" },
    { label: "Oxygen", value: "oxygen-chart" },
    { label: "Bowel", value: "bowel-chart" },
    { label: "Absense", value: "absense" },
    { label: "NEWS2", value: "news2" },
    { label: "Unallocated", value: "unallocated" },
  ];

  const getTabFromUrl = () => {
    const tabParam = searchParams.get("tab");
    if (tabParam && tabs.some((tab) => tab.value === tabParam)) {
      return tabParam;
    }
    return "alerts";
  };

  const [selectedTab, setSelectedTab] = React.useState(getTabFromUrl());

  useEffect(() => {
    const currentTab = getTabFromUrl();
    setSelectedTab(currentTab);
  }, [searchParams]);

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <Card sx={{ p: 2 }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          minHeight: 36,
          "& .MuiTab-root": {
            minHeight: 36,
            py: 0.5,
            px: 1.5,
            fontSize: "0.9rem",
            fontWeight: 500,
            textTransform: "capitalize",
            minWidth: "auto",
            letterSpacing: "0.3px",
          },
          "& .MuiTabs-indicator": {
            height: 2.5,
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>

      <Box sx={{ mt: 0 }}>
        {selectedTab === "alerts" && <AlertContent />}
        {selectedTab === "actions" && <ActionsContent />}
        {selectedTab === "action-issues" && <ActionIssuesContent />}
        {selectedTab === "care-plans" && <CarePlansContent />}
        {selectedTab === "handover" && <HandoverContent />}
        {selectedTab === "dols" && <DolsContent />}
        {selectedTab === "incidents" && <IncidentContent />}
        {selectedTab === "family-share" && <div>Family Share content</div>}
        {selectedTab === "weight-chart" && <WeightsContent />}
        {selectedTab === "fluid-chart" && <FluidChartContent />}
        {selectedTab === "temp-chart" && <TempChartContent />}
        {selectedTab === "oxygen-chart" && <OxygenChartContent />}
        {selectedTab === "bowel-chart" && <BowelChartContent />}
        {selectedTab === "absense" && <RecordAbsenseContent />}
        {selectedTab === "news2" && <NEWS2Content />}
        {selectedTab === "unallocated" && <UnAllocatedCandidates />}
      </Box>
    </Card>
  );
};

export default OperationTabs;